export default "__VITE_ASSET__DgVyukIy__"